import {
  IEntity
} from ".";

export class Entity<TId> implements IEntity<TId> {
  constructor(public id: TId) {
  }

  toString(): string {
    return this.id.toString();
  }

  static areIdsEqual<TId>(source: IEntity<TId>, destination: IEntity<TId>): boolean {
    return (source === destination)
      || (source && destination && (source.id === destination.id));
  }
}
